const UPDATE_MONITOR_ID = 'scratch-gui/currentmonitor/UPDATE_MONITOR_ID';

const initialState = {
    monitorId: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_MONITOR_ID:
        return Object.assign({}, state, {
            monitorId: action.id
        });
    default:
        return state;
    }
};

const updateMonitorId = function (id) {
    return {
        type: UPDATE_MONITOR_ID,
        id: id
    };
};

export {
    reducer as default,
    initialState as currentMonitorInitialState,
    updateMonitorId
};
